var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreate = function SvgCreate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 11.111v7.111c0 .982-.796 1.778-1.778 1.778H5.778A1.777 1.777 0 0 1 4 18.222V5.778C4 4.796 4.796 4 5.778 4h7.11m6.524 2.588c.601-.601.613-1.563.027-2.149-.585-.585-1.547-.573-2.148.028l-8.268 8.267c-.6.601-1.483 2.433-.897 3.019.585.586 2.418-.297 3.018-.897l8.268-8.268Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreate);
export default ForwardRef;